module.exports = __webpack_public_path__ + "img/ill_authorization_down@2x.67e10525.png";